import React from "react";
import isEmpty from "../../../../../store/validation/is-Empty";

export const ViewSubscriptionSection = (props) => {
  const casualDining = props?.data && props?.data?.casual_dining;
  const fastFoodDining = props?.data && props?.data?.fast_food_dining;
  const multiServiceDining = props?.data && props?.data?.multi_service_business;

  return (
    <React.Fragment>
      <div className="row mb-4">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Listing Services</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.listing ||
                fastFoodDining?.listing ||
                multiServiceDining?.listing
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.listing ||
            fastFoodDining?.listing ||
            multiServiceDining?.listing
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Offers Management</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.offer_management ||
                fastFoodDining?.offer_management ||
                multiServiceDining?.offer_management
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.offer_management ||
            fastFoodDining?.offer_management ||
            multiServiceDining?.offer_management
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Scan & Pay</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.scan_and_pay ||
                fastFoodDining?.scan_and_pay ||
                multiServiceDining?.scan_and_pay
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.scan_and_pay ||
            fastFoodDining?.scan_and_pay ||
            multiServiceDining?.scan_and_pay
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Events Management</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.event_management ||
                fastFoodDining?.event_management ||
                multiServiceDining?.event_management
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.event_management ||
            fastFoodDining?.event_management ||
            multiServiceDining?.event_management
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Live Streaming</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.live_streaming ||
                fastFoodDining?.live_streaming ||
                multiServiceDining?.live_streaming
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.live_streaming ||
            fastFoodDining?.live_streaming ||
            multiServiceDining?.live_streaming
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Seating</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.seating ||
                fastFoodDining?.seating ||
                multiServiceDining?.seating
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.seating ||
            fastFoodDining?.seating ||
            multiServiceDining?.seating
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-4">
          <h4 className="font_20_m mb-2">Ordering</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.ordering ||
                fastFoodDining?.ordering ||
                multiServiceDining?.ordering
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.ordering ||
            fastFoodDining?.ordering ||
            multiServiceDining?.ordering
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
        <div className="col-4">
          <h4 className="font_20_m mb-2">Menu Setup</h4>
          <p className="font_16_r c_gray">
            <i
              className={`${
                casualDining?.menu_setup ||
                fastFoodDining?.menu_setup ||
                multiServiceDining?.menu_setup
                  ? "fa fa-check c_green"
                  : "fa fa-times c_red"
              } mr-2`}
              aria-hidden="true"
            ></i>
            {casualDining?.menu_setup ||
            fastFoodDining?.menu_setup ||
            multiServiceDining?.menu_setup
              ? "Activated"
              : "Not Activated"}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};
